<nav class="container bg_black_high_emphasis align_items_center relative">

	<!-- #region Izquierda -->
	<button mat-icon-button class="burger white" (click)="sectionMenuToggle()">
		<mat-icon *ngIf="!bSectionsMenu">menu</mat-icon>
		<mat-icon *ngIf="bSectionsMenu">close</mat-icon>
	</button>

	<a [routerLink]="routerService.HOME" class="margin_right_small">
		<img class="logo_redux pointer" src="/assets/img/logos/ecotopia_redux_negative.svg">
	</a>
	<!-- #endregion -->

	<mat-form-field appearance="fill" class="mobile_search_field flex1 no_vertical_spacing">
		<mat-icon matSuffix class="color_white_high_emphasis">search</mat-icon>
		<input matInput type="text" [formControl]="search" (keydown.enter)="onSearch()" name="search" #searchInput/>
	</mat-form-field>

	<!-- #region Derecha -->
	<div class="overflow_hidden align_items_center padding_left_very_small" *ngIf="user; else login" @fadeInLeft>
		<a mat-icon-button disableRipple [routerLink]="routerService.NOTIFICATIONS">
			<mat-icon class="color_white_high_emphasis" [matBadge]="cNotifications" [matBadgeHidden]="!cNotifications" matBadgeSize="small" matBadgeColor="accent">{{ cNotifications ? "notifications_active" : "notifications" }}</mat-icon>
		</a>
		<a mat-icon-button disableRipple [routerLink]="routerService.CARTS">
			<mat-icon class="color_white_high_emphasis" [matBadge]="cartBadgeNumber" [matBadgeHidden]="!cartBadgeNumber" matBadgeSize="small" matBadgeColor="accent">shopping_cart</mat-icon>
		</a>
		<app-avatar class="margin_left_small pointer" (click)="onAvatarClick()" [size]="'32px'" ></app-avatar>
	</div>
	<ng-template #login>
		<button mat-icon-button class="login_button" (click)="toLogin()">
			<mat-icon class="color_white_high_emphasis">login</mat-icon>
		</button>
	</ng-template>
	<!-- #endregion -->

	<!--
		Este es para cubrir la pantalla atrás de los menús desplegables y detectar el click afuera,
		y bloquear al mismo tiempo el click sobre lo que sea qye se haya tocado.
		Antes lo tenía con una directiva que detecte el click fuera de todo el nav,
		pero eso no me dejaba cortar el click sobre lo que está abajo
	-->
	<div class="menu_background" *ngIf="bSectionsMenu || bCategoriesMenu || bUserMenu" (click)="closeEverything()"></div>

	<!-- #region Desplegables -->
	<div *ngIf="bSectionsMenu" @verticalExpansionSlower class="menu">
		<a (click)="openCategories()" class="item">
			<mat-icon>category</mat-icon>
			<p>Categorías</p>
		</a>
		<a class="item" [routerLink]="routerService.SEARCH" [queryParams]="{d: true}" (click)="closeEverything()">
			<mat-icon>local_offer</mat-icon>
			<p>Ofertas</p>
		</a>
		<a class="item" [routerLink]="routerService.ECOTRENDS" (click)="closeEverything()">
			<mat-icon>compost</mat-icon>
			<p>Ecotrends</p>
		</a>
		<a class="item" [routerLink]="routerService.PRODUCT_FORM" (click)="closeEverything()">
			<mat-icon>paid</mat-icon>
			<p>Vender</p>
		</a>
	</div>

	<div *ngIf="bCategoriesMenu" @verticalExpansionSlower class="menu">
		<button mat-icon-button color="primary" class="back_button" (click)="backToSectionMenu()">
			<mat-icon>arrow_back</mat-icon>
		</button>
		<a class="item" *ngFor="let c of categories" [routerLink]="'/buscar'" [queryParams]="{c: c.id}" (click)="closeEverything()">
			<p>{{c.title}}</p>
		</a>
	</div>

	<div *ngIf="bUserMenu" @verticalExpansionSlower class="menu">
		<a [routerLink]="routerService.PROFILE" class="item" (click)="closeEverything()">
			<mat-icon>manage_accounts</mat-icon>
			<p>Mi Perfil</p>
		</a>
		<a [routerLink]="routerService.MY_PURCHASES" [queryParams]="{tab: eMyPurchasesPageTab.PURCHASES}" class="item" (click)="closeEverything()">
			<mat-icon>shopping_bag</mat-icon>
			<p>Mis Compras</p>
		</a>
		<a [routerLink]="routerService.MY_PURCHASES" [queryParams]="{tab: eMyPurchasesPageTab.QUESTIONS}" class="item" (click)="closeEverything()">
			<mat-icon>quiz</mat-icon>
			<p>Mis Preguntas</p>
		</a>
		<a [routerLink]="routerService.MY_PURCHASES" [queryParams]="{tab: eMyPurchasesPageTab.FAVORITES}" class="item" (click)="closeEverything()">
			<mat-icon>favorite</mat-icon>
			<p>Mis Favoritos</p>
		</a>
	
		<ng-container *ngIf="user!.is_store">
			<p class="p_sell body2 color_white_low_emphasis">VENDER</p>
	
			<a class="item" [routerLink]="routerService.MY_SALES" [queryParams]="{tab: eMySalesPageTabString.SALES}" (click)="closeEverything()">
				<mat-icon>storefront</mat-icon>
				<p>Mis Ventas</p>
			</a>
	
			<a class="item" [routerLink]="routerService.MY_SALES" [queryParams]="{tab: eMySalesPageTabString.QUESTIONS}" (click)="closeEverything()">
				<mat-icon>question_answer</mat-icon>
				<p>Preguntas a mis publicaciones</p>
			</a>

			<a class="item" [routerLink]="routerService.MY_SALES" [queryParams]="{tab: eMySalesPageTabString.PUBLICATIONS}" (click)="closeEverything()">
				<mat-icon>local_offer</mat-icon>
				<p>Mis publicaciones</p>
			</a>
		</ng-container>
	
		<hr class="v_margin_small">
	
		<a class="item" (click)="logout()">
			<mat-icon color="warn">logout</mat-icon>
			<p>Cerrar sesión</p>
		</a>
	</div>
	<!-- #endregion -->
</nav>